import { useEffect, useState } from "react";
import "./style.css";

function CustomProgressCircularLoader(props) {

    const { wpProgress, style = {
        stroke: {
            color: "#d76429",
            width: 5
        }
    } } = props;

    const [progress, setProgress] = useState(0);
    const [newProgress, setNewProgress] = useState(wpProgress?.progress || 0);

    useEffect(() => {
        if (wpProgress?.progress !== undefined) {
            setNewProgress(wpProgress.progress);
        }
    }, [wpProgress?.progress]);

    useEffect(() => {
        if (progress !== newProgress) {
            const isFinalStretch = newProgress === 100;
            const totalDuration = isFinalStretch ? 1000 : Math.abs(newProgress - progress) * 300;
            const stepTime = totalDuration / Math.abs(newProgress - progress);

            const increment = progress < newProgress ? 1 : -1;
            const interval = setInterval(() => {
                setProgress((prev) => {
                    const nextValue = prev + increment;
                    if ((increment > 0 && nextValue >= newProgress) || (increment < 0 && nextValue <= newProgress)) {
                        clearInterval(interval);
                        return newProgress;
                    }
                    return nextValue;
                });
            }, stepTime);

            return () => clearInterval(interval);
        }
    }, [newProgress]);

    const radius = 45; // Circle radius
    const circumference = 2 * Math.PI * radius; // Total length of the circle
    const strokeDashoffset = circumference - (progress / 100) * circumference; // Adjust the stroke length

    return (
        <div className="flex-c">
            <div className="custom-progress-circular-loader flex-c">
                <svg width="120" height="120" viewBox="0 0 100 100">
                    {/* Background Circle */}
                    <circle
                        cx="50"
                        cy="50"
                        r={radius}
                        stroke="#ddd"
                        strokeWidth={style?.stroke?.width}
                        fill="none"
                    />
                    {/* Animated Progress Circle */}
                    <circle
                        cx="50"
                        cy="50"
                        r={radius}
                        stroke={style?.stroke?.color} // Change color as needed
                        strokeWidth={style?.stroke?.width}
                        fill="none"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        strokeLinecap="round"
                        transform="rotate(-90 50 50)" // Starts from top
                        style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
                    />
                </svg>
                <em className="progress-text">{progress}%</em>
            </div>
        </div>
    );
}

export default CustomProgressCircularLoader;